import * as React from 'react';
import * as classNames from 'classnames';
import { Icon } from './Icon';

export const ARROW_DIRECTION = Object.freeze({
    LEFT_DIRECTION: 'left',
    RIGHT_DIRECTION: 'right',
    TOP_DIRECTION: 'top',
    BOTTOM_DIRECTION: 'bottom'
});

export interface IDirectionalArrowProps {
    className?: string;
    direction?: string;
}

const DirectionalArrow = (props: IDirectionalArrowProps) => {
    const className = classNames('elc-directional-icon', props.className);
    const image = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' preserveAspectRatio='none' fill='transparent' stroke-width='2px'%0Astroke='%23000000' %3E%3Cpath d='M1,6 L10,15 L19,6' /%3E%3C/svg%3E")`;
    const transform =
        (props.direction === ARROW_DIRECTION.LEFT_DIRECTION && 'rotate(90deg)') ||
        (props.direction === ARROW_DIRECTION.TOP_DIRECTION && 'rotate(180deg)') ||
        (props.direction === ARROW_DIRECTION.RIGHT_DIRECTION && 'rotate(270deg)') ||
        '';

    return <Icon className={className} size={'small'} image={image} transform={transform} />;
};

export { DirectionalArrow };
